export const selectItems = (state: StateData) => {
  return state?.items;
};
// export const getUserId = (state: StateData) => {
//   return state?.userId;
// };

export const selectFormsWithUnsavedChanges = (state: StateData) =>
  state.formsWithUnsavedChanges;
